import { render, staticRenderFns } from "./AddresTable.vue?vue&type=template&id=17cd397e"
import script from "./AddresTable.vue?vue&type=script&lang=js"
export * from "./AddresTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports